<template>
  <v-card flat>
    <v-toolbar dense elevation="0">
      <v-toolbar-title centered class="headline font-weight-bold">
        {{ network.type | title }}(s)
      </v-toolbar-title>
      <v-spacer />
      <v-chip class="ma-2" color="primary" text-color="white">
        <v-avatar left class="primary darken-4">
          {{ network.agents_count }}
        </v-avatar>
        Agent(s)
      </v-chip>
      <div class="flex-grow-1"></div>
      <div>
        <v-switch :value="network.is_active" label="Activate" inset color="primary" class="mt-5" />
      </div>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text>
      <v-row>
        <v-col cols="4">
          <key-value title="Token" :value="network.token_owned" type="currency" />
          <key-value
            title="Commission"
            :value="network.token_commission_collected"
            type="currency"
          />
        </v-col>
        <v-col cols="4">
          <key-value title="Activity status">
            <v-icon color="success" size="35" v-if="network.is_active">
              mdi-progress-check
            </v-icon>

            <v-icon color="warning" size="35" v-else>
              mdi-progress-alert
            </v-icon>
          </key-value>
          <key-value title="Crypto Balance" :value="network.crypto_balance" type="currency" />
        </v-col>
        <v-col cols="4">
          <key-value title="Token Delta" type="currency">
            <div class="d-flex">
              <span class="mr-3">{{ network.token_delta | currency }}</span>
              <v-icon color="primary" v-if="network.token_amount_matched">
                mdi-progress-check
              </v-icon>

              <v-icon color="error" v-else> mdi-progress-alert</v-icon>
            </div>
          </key-value>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    network: {
      required: true,
      type: Object,
    },
  },
  methods: {
    timeAgo(value) {
      return value;
    },
  },
};
</script>
